import { call, put, takeEvery } from 'redux-saga/effects';
import { REMOVE_USER_PHONE_REQUEST } from '../../constants/user_phones.constants';
import { removeUserPhone } from '../../../requests/user_phones_requests/remove_user_phone_request';
import { removeUserPhoneRequestSuccess, removeUserPhoneRequestFailure } from '../../actions/user_phones_actions/remove_user_phone.actions';
import { message_success, message_error } from '../../../../../../components/Message';

function* removeUserPhoneRequest({ phone_id, user_id }) {
    const {
        result, options, msg, error,
    } = yield call(removeUserPhone, phone_id, user_id);
    if (result) {
        yield put(removeUserPhoneRequestSuccess(options.person.phones));
        message_success('Phone removed successfully!');
    } else {
        yield put(removeUserPhoneRequestFailure(error));
        message_error(msg);
    }
}

export default function* removeUserPhoneSaga() {
    yield takeEvery(REMOVE_USER_PHONE_REQUEST, removeUserPhoneRequest);
}



// WEBPACK FOOTER //
// ./src/modules/UserManagement/User_profile/redux/sagas/user_phones_sagas/remove_user_phone.saga.js